import { typography } from '../../../base/styled/typography.style';
import { colors } from "../../../base/styled/variables.styled";
import styled from "styled-components";
export const CheckboxBlockStyle = styled.div `
	display: flex;
	flex-direction: column;
	gap: 1rem;
	max-width: 100%;

	&.container,
	&.container__large,
	&.container__medium,
	&.container__small {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}

	svg {
		position: absolute;
		width: 12px;
		height: 12px;
		top: 7px;
		left: 3px;
		pointer-events: none;
		cursor: pointer;
		z-index: 1;
		
		@media screen and (-webkit-min-device-pixel-ratio:0) {
			_::-webkit-full-page-media, _:future, :root & {
				left: 3px !important;
			}
		}
	}
`;
export const CheckboxBlockLabelStyle = styled.label.withConfig({
    shouldForwardProp: (prop) => !['disabled'].includes(prop),
}) `
	&.checkbox-label--disabled {
		color: ${colors.neutral400}!important;
		cursor: not-allowed!important;
	}

	&.not{
		cursor:not-allowed;
		color: ${colors.neutral400}!important;
	}

	${({ disabled }) => disabled &&
    `
			cursor: not-allowed;
			color: ${colors.neutral400}!important;
			opacity: 0.6;
		`}

	color: ${colors.neutral800};
	${typography.body1};
	opacity: 1;
	position: relative;
	display: flex;
`;
export const CheckboxBlockInputStyle = styled.input `
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	width: 18px;
	height: 18px;
	background-color: #fff;
	border: 2px solid ${colors.brand200};
	border-radius: 4px;
	cursor: pointer;
	margin-right: 10px;
	transition: all 0.2s ease-in-out;
	
	&:disabled {
		color: ${colors.neutral400}!important;
	}

	&:checked {
		background-color: ${colors.brand500};
		border-color: ${colors.brand500};
		outline: none!important;

		&:before{
			position: relative;
			display: block;
			content: "";
			background: #FFF;
		}
	}
`;
//# sourceMappingURL=Checkbox.style.js.map